import { createAnonAxios } from "./vg2AnonAxios";

const API_V2 = `${process.env.REACT_APP_BACKEND_URL}/api/v2`;
const api = createAnonAxios(API_V2);

export const getValutaContext = async (jid) =>
  (await api.get(`/journeys/${jid}/valuta/context`)).data;

export const setValuationMode = async (jid, mode) =>
  (await api.post(`/journeys/${jid}/valuta/set-mode`,
    { valuation_mode: mode })).data;

export const patchFeatures = async (jid, features) =>
  (await api.patch(`/journeys/${jid}/valuta/features`, { features })).data;

export const patchValutaAddress = async (jid, street, municipality, houseNumber) =>
  (await api.patch(`/journeys/${jid}/valuta/address`,
    { street, municipality, house_number: houseNumber || null })).data;

export const runValutaSingle = async (jid, payload) =>
  (await api.post(`/journeys/${jid}/valuta/run-single`, payload)).data;

export const runValuation = async (caseId, operationId) =>
  (await api.post(`/cases/${caseId}/valuation`, { operation_id: operationId })).data;

export const recordAnalysis = async (jid, analysisId) =>
  (await api.post(`/journeys/${jid}/valuta/record-analysis`,
    { analysis_id: analysisId })).data;

export const getValuationLatest = async (caseId) =>
  (await api.get(`/cases/${caseId}/valuation/latest`)).data;

export const getValuationById = async (caseId, analysisId) =>
  (await api.get(`/cases/${caseId}/valuations/${analysisId}`)).data;

export const getZoneMarketContext = async (caseId, analysisId) =>
  (await api.get(
    `/market/cases/${caseId}/valuations/${analysisId}/zone-context`)).data;

export function valutaOpIdKey(jid) { return `vg2_valuta_op_${jid}`; }
export function getValutaOpId(jid) {
  let op = localStorage.getItem(valutaOpIdKey(jid));
  if (!op) {
    op = "vop_" + Math.random().toString(36).slice(2, 14);
    localStorage.setItem(valutaOpIdKey(jid), op);
  }
  return op;
}
